import { BaseQuestionnaireRoute } from '../slice';
import {
  saleofOtherAssetsRoutes,
  SaleofOtherAssetsRoutes,
} from './saleofOtherAssets';
import {
  soleProprietorshipForm1099MISCand1099NECRoutes,
  SoleProprietorshipForm1099MISCand1099NECRoutes,
} from './soleProprietorshipForm1099MISCand1099NEC';

export type SoleProprietorshipRoutes = BaseQuestionnaireRoute & {
  soleProprietorshipForm1099MISCand1099NEC: SoleProprietorshipForm1099MISCand1099NECRoutes;
  saleofOtherAssets: SaleofOtherAssetsRoutes;
};

export const soleProprietorshipRoutes: {
  soleProprietorship: SoleProprietorshipRoutes;
} = {
  soleProprietorship: {
    title: 'Income',
    path: 'soleProprietorship',
    isValid: undefined,
    ...soleProprietorshipForm1099MISCand1099NECRoutes,
    ...saleofOtherAssetsRoutes,
  },
};
